import styled from 'styled-components'
import { device } from '../../../styles/Breakpoints'
import { HeroWrapper } from '../../../styles/Wrappers'
import { Centered, HeroContentContainer, HeroCopy, Wrapper } from '../../Hero/Hero.styles'
import { VSMHeroImgStyles } from './VSMHeroImg.styles'

export const MidSection = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f5faea;
	margin: 0 auto;
	width: 100%;
	z-index: -1;
	height: 310px;

	@media ${device.xs} {
		height: 225px;
	}

	@media ${device.md} {
		height: 293px;
	}

	@media ${device.lg} {
		height: 310px;
	}
`

export const MidSectionContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
	justify-content: center;
	align-items: center;
	padding-top: 20px;
	padding-bottom: 10px;

	${HeroContentContainer} {
		padding-top: 20px;
	}

	${HeroCopy} {
		text-align: center;
		padding: 20px;
	}
`

export const VSMHeroContainer = styled.div`
	${HeroWrapper} {
		margin-bottom: 0;

		h3.hero-label {
			letter-spacing: 5px;

			@media ${device.sm} {
				letter-spacing: 7px;
			}
		}

		h1.hero-title {
			margin: 10px 0;
			padding: 0 10px;
		}
	}

	${Wrapper} {
		position: relative;
		height: 420px;

		@media only screen and (min-width: 380px) {
			height: 360px;
		}

		@media only screen and (min-width: 536px) {
			height: 330px;
		}

		@media ${device.xs} {
			height: 300px;
		}

		${HeroCopy} {
			p {
				font-size: 18px;
				line-height: 1.57;
				margin: 0;
				padding: 0 20px;
			}

			width: 100%;

			@media ${device.md} {
				width: 60%;
			}

			&.midsection {
				order: 4;
				text-align: center;
			}
		}

		${Centered} {
			padding: 0;
			padding-top: 20px;

			${HeroCopy} {
				color: #fff;
			}
		}

		${HeroContentContainer} {
			position: absolute;
			top: 0;
			width: 100%;
			padding: 0;
			flex-direction: column;

			${VSMHeroImgStyles} {
				order: 3;
				width: 100%;
			}

			// img {
			// 	order: 3;
			// 	width: 100%;
			// }
		}
	}
`

export const TabSection = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	position: relative;
	z-index: 0;

	p {
		margin-top: 0;
	}
`

export const TabSectionTab = styled.span`
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	width: 10em;
	position: absolute;
	top: -50px;
	z-index: 10;
	padding: 22px 0px;

	@media ${device.sm} {
		width: 18em;
		top: -40px;
		padding: 20px 0px;
	}

	&:before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 17px;
		left: 0;
		z-index: -1;
		border-bottom: none;
		border-radius: 0.4em 0.4em 0 0;
		transform: scale(1.2, 1.3) perspective(0.5em) rotateX(5deg);
		transform-origin: top;
		background: #fff;
	}
`

export const TabSectionTopBar = styled.div`
	width: 100%;
	border: 1px solid #fff;
	position: relative;
	display: flex;
	justify-content: center;

	p.tab-label {
		position: absolute;
		bottom: -10px;
		z-index: 10;
		color: #000;
		text-transform: uppercase;
		font-size: 13px;
		letter-spacing: 0.3em;
		font-weight: 600;
		font-family: 'Source Sans Pro', sans-serif;
		width: 200px;
		text-align: center;

		@media ${device.sm} {
			width: unset;
			bottom: -5px;
		}
	}
`
